/*
 * Copyright Huesik (c) 2019.
 */

import KosiwonConstant from '../const/kosiwons'
import _ from 'underscore'
import FilterConstant from '../const/filters'

_.deepClone = function(obj) {
  return (!obj || (typeof obj !== 'object'))?obj:
    (_.isString(obj))?String.prototype.slice.call(obj):
      (_.isDate(obj))?new Date(obj.valueOf()):
        (_.isFunction(obj.clone))?obj.clone():
          (_.isArray(obj)) ? _.map(obj, function(t){return _.deepClone(t)}):
            _.mapObject(obj, function(val) {return _.deepClone(val)})
}

const mutations = {
  SET_RANKING_IS_HIDE (state, isHide) {
    state.RANKING_LIST.IS_HIDE = isHide
  },
  SET_SEARCH_LAT (state, lat) {
    state.SEARCH.LATITUDE = lat
  },
  SET_SEARCH_LNG (state, lng) {
    state.SEARCH.LONGITUDE = lng
  },
  SET_BOUNDS_DISTANCE (state, distance) {
    state.MAPS.BOUND_DISTANCE = distance
  },
  SET_MAP (state, map) {
    state.MAPS.MAP = map
  },
  SET_MAP_CENTER (state, latlng) {
    state.MAPS.CENTER = {
      LATITUDE: latlng.latitude,
      LONGITUDE: latlng.longitude
    }
  },
  SET_MAP_BOUNDS (state, bounds) {
    state.MAPS.BOUNDS.SW = bounds.sw
    state.MAPS.BOUNDS.NE = bounds.ne
  },
  SET_SEARCH_KOSIWON_LIST (state, kosiwonList) {
    state.SEARCH.KOSIWON_LIST = kosiwonList
  },
  SET_OPEN_STATUS (state, openState) {
    state.SEARCH.OPEN_STATUS = openState
  },
  SET_HOVER_KOSIWON (state, kosiwon) {
    state.SEARCH.HOVER_KOSIWON = kosiwon
  },
  SET_MONEY_RANGE (state, moneyRange) {
    state.FILTERS.MONEY_RANGE = moneyRange
  },
  SET_USE_SEX_TYPE (state, type) {
    const hasItemIndex = state.FILTERS.USE_SEX_TYPE.indexOf(type)
    if (hasItemIndex > -1) {
      state.FILTERS.USE_SEX_TYPE.splice(hasItemIndex, 1)
    } else {
      state.FILTERS.USE_SEX_TYPE.push(type)
    }
  },
  TOGGLE_OPTIONS_FILTER (state, key) {
    state.FILTERS.OPTIONAL_FILTER[key] = !state.FILTERS.OPTIONAL_FILTER[key]
  },
  TOGGLE_ROOM_TYPE (state, type) {
    const hasItemIndex = state.FILTERS.ROOM_TYPE.indexOf(type)
    if (hasItemIndex > -1) {
      state.FILTERS.ROOM_TYPE.splice(hasItemIndex, 1)
    } else {
      state.FILTERS.ROOM_TYPE.push(type)
    }
  },
  RESET_FILTER_STATE (state) {
    state.FILTERS = _.deepClone(FilterConstant.DEFAULT_FILTERS)
  },
  SET_LOGIN (state, {accessToken, refreshToken}) {
    state.USERS.ACCESS_TOKEN = accessToken
    state.USERS.REFRESH_TOKEN = refreshToken
  },
  LOGOUT (state) {
    state.USERS.ACCESS_TOKEN = null
    state.USERS.REFRESH_TOKEN = null
  },
  SET_PICK_LIST (state, kosiwon) {
    state.INTEREST.PICK_LIST.push(kosiwon)
  },
  REMOVE_PICK_LIST (state, kosiwon) {
    state.INTEREST.PICK_LIST = _.filter(state.INTEREST.PICK_LIST, (pickList) => {
      return pickList.pk !== kosiwon.pk
    })
  },
  SET_LAST_VIEW_LIST (state, kosiwon) {
    console.log(state.INTEREST.LAST_VIEW_LIST)
    const duplicate  = _.find(state.INTEREST.LAST_VIEW_LIST, item => {
      return item.pk === kosiwon.pk
    })

    if (duplicate) {
      return
    }

    if (state.INTEREST.LAST_VIEW_LIST.length > KosiwonConstant.LAST_VIEW_LIST_MAX_COUNT) {
      state.INTEREST.LAST_VIEW_LIST = state.INTEREST.LAST_VIEW_LIST.splice(-1, 1)
    }

    state.INTEREST.LAST_VIEW_LIST.unshift(kosiwon)
  },
  TOGGLE_NETWORK_INDICATOR (state) {
    state.NETWORK.SHOW_INDICATOR = !state.NETWORK.SHOW_INDICATOR
  },

  SET_NETWORK_INDICATOR (state, value) {
    state.NETWORK.SHOW_INDICATOR = value
  },
  SET_IS_NATIVE (state, isNative) {
    state.APP.IS_NATIVE = isNative
  },
  SET_APP_FIRST_LOADING(state, isFirstLoading) {
    state.APP.FIRST_LOADING = isFirstLoading
  }

}

export default mutations
